import React, { useState, useEffect } from 'react';
import { connectPagination } from 'react-instantsearch-dom';
import { StyledLoadContainer } from './styled';
import { TrackingRelNext } from './components/TrackingRelNext';
import { LoadNextPage } from '$features/productsList/components/LoadNextPage';
import { LoadPreviousPage } from '$features/productsList/components/LoadPreviousPage';
import { Dropdown, DropdownItem } from '$shared/components/Dropdown/Dropdown';
import { useTranslation } from '$shared/utils';
import { useRouter } from 'next/router';

/** Pagination type recreated from props referred in Algolia documentation.
 * The pagination type appears to be built within multiple levels
 * in Algolia SDK and it's not directly exposed. */
type PaginationProps = {
    currentRefinement: number; // The position of the current page.
    nbPages?: number; // The total number of existing pages.
    refine: (page: number) => void; // func to select a page.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    createURL: (...args: any[]) => any;
};

type Props = PaginationProps;

const CustomPagination = (props: Props) => {
    const { translate } = useTranslation();
    const { asPath, push } = useRouter();
    const [items, setItems] = useState<DropdownItem[]>([]);
    const path = asPath.split('?')[0];
    const { nbPages, currentRefinement } = props;
    const currentUrl = props.createURL();
    const previousPageUrl = `${path}${currentUrl}&page=${currentRefinement - 1}`;
    const nextPageUrl = `${path}${currentUrl}&page=${currentRefinement + 1}`;
    const goToUrl = `${path}${currentUrl}&page=`;
    const nextDisabled = !nbPages || currentRefinement >= nbPages;
    const previousDisabled = !nbPages || currentRefinement <= 1;

    useEffect(() => {
        if (nbPages) {
            setItems(
                Array.from({ length: nbPages }, (_, i) => ({
                    value: i + 1,
                    label: `${translate('general.page')} ${i + 1}/${nbPages}`,
                }))
            );
        }

        return () => setItems([]);
    }, [nbPages, translate]);

    const goToPage = (page: number | string) => {
        push(`${goToUrl}${page}`);
    };

    return (
        <StyledLoadContainer>
            <LoadPreviousPage disabled={previousDisabled} url={previousPageUrl} />
            <Dropdown
                asSecondaryButton={true}
                name="product-list-pagination"
                items={items}
                value={currentRefinement}
                onChange={goToPage}
            />
            <LoadNextPage disabled={nextDisabled} url={nextPageUrl} />
            <TrackingRelNext currentPage={currentRefinement} />
        </StyledLoadContainer>
    );
};

export const Pagination = connectPagination(CustomPagination);
